<template id="map-template">
  <div class="homeview-fast-track-entrance">
    <div class="header">
      <span class="header-title">快速入口</span>
      <div class="arrow-pic"></div>
    </div>
    <div class="table-chart">
      <div class="fask-track-entrance-list">
        <div
          class="list-item"
          v-for="item in dict.type.fask_track_entrance"
          :key="item.value"
          @click="handleClick(item.value)"
        >
          <i class="el-icon-share"></i>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeViewFastTrackEntrance",
  componentName: "HomeViewFastTrackEntrance",
  components: {},
  props: {},
  dicts: ["fask_track_entrance"],
  data() {
    return {
      shortcuts: [],
    };
  },
  methods: {
    handleClick(url) {
      if (url) {
        if (url.includes("http")) {
          window.open(url);
        } else {
          this.$router.push({
            path: url,
            query: {},
          });

          // eslint-disable-next-line no-undef
          $(".zj-app").removeClass("zj-emergencyoperations-map");
        }
      } else {
        this.$message({
          type: "warning",
          message: "快速入口菜单地址未配置",
        });
      }
    },
  },
  created() {
    //this.search();
  },
  mounted() {},
};
</script>